import { useCallback, useRef } from 'react'
import { useBlocker } from '@tanstack/react-router'
import type { ShouldBlockFn } from '@tanstack/react-router'
import { shouldBlockUnsavedRouteLeave } from './unsavedChangesGate'

type UsePlannerLeaveGuardArgs = {
  hasUnsavedChanges: boolean
}

export function usePlannerLeaveGuard({ hasUnsavedChanges }: UsePlannerLeaveGuardArgs) {
  const hasUnsavedChangesRef = useRef(hasUnsavedChanges)
  hasUnsavedChangesRef.current = hasUnsavedChanges

  const shouldBlockFn = useCallback<ShouldBlockFn>(
    ({ current, next }) => shouldBlockUnsavedRouteLeave(hasUnsavedChangesRef.current, current.pathname, next.pathname),
    []
  )

  const leaveBlocker = useBlocker({
    shouldBlockFn,
    enableBeforeUnload: hasUnsavedChanges,
    withResolver: true,
  })

  const suppressUnsavedFlag = useCallback(() => {
    hasUnsavedChangesRef.current = false
  }, [])

  return {
    hasUnsavedChanges,
    hasUnsavedChangesRef,
    leaveBlocker,
    suppressUnsavedFlag,
  }
}
